<template>
  <b-modal
    size="lg"
    id="edit_modal"
    ref="modal"
    :title="langTitle"
    :busy="loading"
  >
    <b-overlay variant="card" :show="loading">
      <b-alert variant="danger" :show="error != null">{{ error }}</b-alert>
      <b-form class="form" @submit.prevent="doSubmit">
        <b-tabs content-class="mt-3">
          <form-basic-info :form="$v.form"></form-basic-info>
          
          <form-source :form="$v.form"></form-source>

          <form-schedule
            :form="$v.form"
            :schedules="form.schedule_items"
            :station-time-zone="stationTimeZone"
            @add-schedule="addScheduleItem"
            @remove-schedule="removeScheduleItem"
          ></form-schedule>

          <form-advanced
            :form="$v.form"
          ></form-advanced>

        </b-tabs>

        <invisible-submit-button />
      </b-form>
    </b-overlay>
    <template v-slot:modal-footer>
      <b-button variant="default" type="button" @click="close">
        Close
      </b-button>
      <b-button
        variant="info"
        type="submit"
        @click="doSubmit"
        :disabled="$v.form.$invalid"
      >
        Save Changes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from "vuelidate";
import required from "vuelidate/src/validators/required";
import FormBasicInfo from "./Form/BasicInfo";
import FormSource from "./Form/Source";
import FormSchedule from "./Form/Schedule";
import FormAdvanced from "./Form/Advanced";
import InvisibleSubmitButton from "@/components/common/InvisibleSubmitButton";
import ApiService from "@/plugins/ApiService";
export default {
  name: "EditModal",
  components: { 
      FormSchedule, 
      FormBasicInfo, 
      FormAdvanced,
      FormSource,
      InvisibleSubmitButton 
      },
  mixins: [validationMixin],
  props: {
    createUrl: String,
    stationTimeZone: String,
    enableAdvancedFeatures: Boolean,
  },
  data() {
    return {
      loading: true,
      error: null,
      editUrl: null,
      form: {},
    };
  },
  computed: {
    langTitle() {
      return this.isEditMode ? "Edit Playlist" : "Add Playlist";
    },
    isEditMode() {
      return this.editUrl !== null;
    },
  },
  validations: {
    form: {
      name: { required },
      is_enabled: { required },
      // 'include_in_on_demand': {},
      weight: { required },
      type: { required },
      playback_order: { required },
      is_jingle: {},
      play_per_tracks: {},
      play_per_minutes: {},
      play_per_hour_minute: {},
      include_in_station_requests: {},
      include_in_automation: {},
      avoid_duplicates: {},
      backend_options: {},
      schedule_items: {
        $each: {
          start_time: { required },
          end_time: { required },
          start_date: {},
          end_date: {},
          days: {},
        },
      },
    },
  },
  methods: {
    resetForm() {
      this.form = {
        name: "",
        is_enabled: true,
        include_in_on_demand: false,
        weight: 3,
        type: "default",
        playback_order: "shuffle",
        is_jingle: false,
        play_per_tracks: 0,
        play_per_minutes: 0,
        play_per_hour_minute: 0,
        include_in_station_requests: true,
        avoid_duplicates: true,
        backend_options: [],
        schedule_items: [],
        station: this.stationId,
      };
    },
    create() {
      this.resetForm();
      this.loading = false;
      this.error = null;
      this.editUrl = null;

      this.$refs.modal.show();
    },
    edit(playlist) {
      //console.log(playlist);
      this.resetForm();
      this.loading = false;
      this.error = null;
      this.editUrl = `admin/playlists/${playlist.id}`;

      this.form = {
        name: playlist.name,
        playlist_id: playlist.id,
        is_enabled: !!playlist.is_enabled,
        // 'include_in_on_demand': playlist.include_in_on_demand,
        weight: playlist.weight,
        type: playlist.type,
        playback_order: playlist.playback_order || 'shuffle',
        is_jingle: !!playlist.is_jingle,
        play_per_tracks: playlist.play_per_tracks,
        play_per_minutes: playlist.play_per_minutes,
        play_per_hour_minute: playlist.play_per_hour_minute,
        include_in_station_requests: !!playlist.include_in_station_requests,
        avoid_duplicates: !!playlist.avoid_duplicates,
        backend_options: playlist.backend_options || [],
        schedule_items: playlist.schedule_items || [],
        station: playlist.station,
      };

      this.$refs.modal.show();
    },
    doSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      // console.log(this.form);

      this.error = null;

      ApiService.axios(
        this.isEditMode,
        this.isEditMode ? this.editUrl : this.createUrl,
        this.form
      )
        .then((resp) => {
          let notifyMessage = "Changes saved.";
          // notify('<b>' + notifyMessage + '</b>', 'success', false);

          this.$emit("relist");
          this.close();
        })
        .catch((error) => {
          let notifyMessage =
            "An error occurred and your request could not be completed.";

          if (error.response) {
            // Request made and server responded
            notifyMessage = error.response.data.message;
            console.log(notifyMessage);
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }

          this.error = notifyMessage;
        });
    },
    close() {
      this.loading = false;
      this.error = null;
      this.editUrl = null;
      this.resetForm();

      this.$v.form.$reset();
      this.$refs.modal.hide();
    },
    addScheduleItem(item) {
      this.form.schedule_items.push(item);
    },
    removeScheduleItem(index) {
      this.form.schedule_items.splice(index, 1);
    },
  },
};
</script>
